import { Dialog, Transition } from "@headlessui/react";
import { Fragment, useEffect, useState } from "react";
import SuccessIcon from "../../images/success.svg";
import ErrorIcon from "../../images/noItem.svg"
export default function CustomAlert(props) {
  function closeModal() {
    props.hide();
  }

 
  return (
    <>
      <Transition appear show={true} as={Fragment}>
        <Dialog as="div" className="relative z-[999999]" onClose={closeModal}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black/25" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                  <Dialog.Title
                    as="h3"
                    className="text-lg font-medium leading-6 text-gray-900"
                  >
                    <div className="flex items-center gap-3">
                      {props.successShow == true && (
                        <img className="w-10 h-10" src={SuccessIcon} alt="" />
                      )}
                      {props.errorShow == true && (
                        <img className="w-10 h-10" src={ErrorIcon} alt="" />
                      )}
                      <div className="text-base font-semibold">{props.heading}</div> 
                    </div>
                  </Dialog.Title>
                  <div className="mt-2">
                    <p className="text-sm text-gray-500">{props.para}</p>
                  </div>

                  {!props.successShow && !props.errorShow &&
                    <div className="mt-4 flex justify-end">
                      {(props.heading != "Are You Sure?" && props.heading != "Do You want to cancel?") && (
                        <button
                          type="button"
                          className="inline-flex justify-center rounded-md border border-transparent bg-[#3d38af] px-4 py-2 text-sm font-medium text-white hover:bg-blue-900 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
                          onClick={closeModal}
                        >
                          ok thanks
                        </button>
                      )}
                      {(props.heading == "Are You Sure?" || props.heading == "Do You want to cancel?") && (
                        <div className="flex items-center gap-2">
                          <button
                            type="button"
                            className="inline-flex justify-center rounded-md border border-transparent bg-[#3d38af] px-5 py-2 text-sm font-medium text-white hover:bg-blue-900 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
                            onClick={()=>{props.submitRequest(props.serviceId)}}
                          >
                            
                            yes
                          </button>
                          <button
                            type="button"
                            className="inline-flex justify-center rounded-md border border-transparent bg-blue-100 px-5 py-2 text-sm font-medium text-blue-900 hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
                            onClick={closeModal}
                          >
                            No
                          </button>
                        </div>
                      )}
                    </div>
                  }
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
}
